import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface VerifyPuzzlePayload {
  puzzleId: number;
  fen: string;
  move: string;
  moveCount: number;
  timeEnded: boolean;
  meetingRole: number;
  source?: string;
}

export default function useVerifyPuzzleApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, VerifyPuzzlePayload> {
  return useMutation<any, unknown, VerifyPuzzlePayload>(
    async (payload: VerifyPuzzlePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/verify_puzzle_move/',
        payload,
      );
      console.log('Verify Puzzle in Classroom = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to Verify Classroom Puzzle:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
